import appleIcon from "..//assets/res/apple_white.svg";
import androidIcon from "..//assets/res/android_white.svg";
import downloadIcon from "..//assets/res/download_icon.svg";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { GET_BASE_URL } from "../utils/Constants";

const VerticalListItem = ({ game, handleItemClick, isForSearch = false }) => {
  const { name, image_path, rate, isForAndroid, isForIos, download } = game;

  return (
    <div
      className="mx-3 mt-2.5 rounded-2xl cursor-pointer active:scale-[0.98] transition-transform duration-150"
      style={{
        background: "rgba(255,255,255,0.04)",
        border: "1px solid rgba(255,255,255,0.07)",
      }}
      onClick={() => handleItemClick(game)}
    >
      <div className="flex flex-row items-center p-3 gap-3">
        <div className="h-[72px] w-[72px] rounded-2xl bg-gray-800 flex-none overflow-hidden shadow-lg">
          <LazyLoadImage
            className="h-[72px] w-[72px] object-cover object-center"
            src={GET_BASE_URL() + "images/" + image_path}
            alt={name}
          />
        </div>

        <div className="flex flex-col justify-center flex-1 min-w-0">
          <div className="text-white semiBold text-lg leading-tight truncate">
            {name}
          </div>
          <div className="flex flex-row items-center gap-1.5 mt-1">
            {isForAndroid && (
              <img src={androidIcon} className="h-3.5 w-3.5 opacity-60" alt="Android" />
            )}
            {isForIos && (
              <img src={appleIcon} className="h-3.5 w-3.5 opacity-60" alt="iOS" />
            )}
            {download && (
              <span className="text-gray-500 text-xs medium">
                · {download}K downloads
              </span>
            )}
          </div>
        </div>

        {isForSearch ? (
          <div
            className="rounded-full semiBold text-sm px-5 py-1.5 shrink-0"
            style={{
              background: "linear-gradient(135deg, #01497c, #468faf)",
              color: "#fff",
              letterSpacing: "0.04em",
            }}
            onClick={() => handleItemClick(game)}
          >
            Get
          </div>
        ) : (
          <div
            className="h-11 w-11 rounded-2xl flex items-center justify-center shrink-0"
            style={{
              background: "rgba(70,143,175,0.15)",
              border: "1px solid rgba(70,143,175,0.3)",
            }}
          >
            <img src={downloadIcon} className="h-5 w-5" alt="Download" />
          </div>
        )}
      </div>
    </div>
  );
};

export default VerticalListItem;
